// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import type {FreeProClaimResponse, FreeProStatusResponse} from '@fluxer/schema/src/domains/premium/FreeProSchemas';
import type {
	ShopierCosmeticKindSchema,
	ShopierOverviewResponse,
	ShopierPlanSchema,
	ShopierPurchaseResponse,
	ShopierStoreResponse,
} from '@fluxer/schema/src/domains/premium/ShopierSchemas';

export async function fetchShopierOverview(): Promise<ShopierOverviewResponse> {
	const response = await http.get<ShopierOverviewResponse>(Endpoints.PREMIUM_SHOPIER);
	return response.body;
}

export async function createShopierPurchase(plan: ShopierPlanSchema): Promise<ShopierPurchaseResponse> {
	const response = await http.post<ShopierPurchaseResponse>(Endpoints.PREMIUM_SHOPIER_PURCHASES, {body: {plan}});
	return response.body;
}

export async function fetchStore(): Promise<ShopierStoreResponse> {
	const response = await http.get<ShopierStoreResponse>(Endpoints.STORE);
	return response.body;
}

export async function createStorePurchase(
	kind: ShopierCosmeticKindSchema,
	itemId: string,
): Promise<ShopierPurchaseResponse> {
	const response = await http.post<ShopierPurchaseResponse>(Endpoints.STORE_PURCHASES, {body: {kind, item_id: itemId}});
	return response.body;
}

export async function fetchFreeProStatus(): Promise<FreeProStatusResponse> {
	const response = await http.get<FreeProStatusResponse>(Endpoints.PREMIUM_FREE_PRO);
	return response.body;
}

export async function claimFreePro(): Promise<FreeProClaimResponse> {
	const response = await http.post<FreeProClaimResponse>(Endpoints.PREMIUM_FREE_PRO_CLAIM);
	return response.body;
}
